<template>
  <div class="application_not">
    <div class="top">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>未受理的申请</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="main">
      <div class="main_drop">
        <p class="main_drop_title">
          <i class="el-icon-menu"></i>
          等待受理的申请
        </p>
        <div class="main_drop_content">
          <el-table
            class="mytable"
            ref="multipleTable"
            :data="tableData"
            border
            highlight-current-row
            tooltip-effect="dark"
          >
            <el-table-column
              type="index"
              width="50"
              label="序号"
              align="center"
            >
            </el-table-column>
            <el-table-column label="申请编号" align="center">
              <template slot-scope="scope">{{
                scope.row.apply_number
              }}</template>
            </el-table-column>
            <!-- <el-table-column label="项目编号" align="center">
              <template slot-scope="scope">{{
                scope.row.project_number
              }}</template>
            </el-table-column> -->
            <el-table-column label="委托单位" align="center">
              <template slot-scope="scope">{{
                scope.row.enterprise_client_name
              }}</template>
            </el-table-column>
            <el-table-column label="生产商" align="center">
              <template slot-scope="scope">{{
                scope.row.enterprise_manufacturer_name
              }}</template> </el-table-column
            ><el-table-column label="检测产品" align="center">
              <template slot-scope="scope">{{
                scope.row.product_name
              }}</template>
            </el-table-column>
            <el-table-column label="产品类型" align="center">
              <template slot-scope="scope">{{
                scope.row.product_model
              }}</template>
            </el-table-column>
            <el-table-column label="时间" align="center">
              <template slot-scope="scope">{{
                scope.row.utime | formatDate(scope.row.utime)
              }}</template>
            </el-table-column>
            <el-table-column label="备注" width="160" align="center">
              <template slot-scope="scope">{{
                scope.row.audit_remarks == "-1"
                  ? "等待中"
                  : scope.row.audit_remarks
              }}</template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="main_drop">
        <p class="main_drop_title">
          <i class="el-icon-menu"></i>
          需修改或补充信息的申请
        </p>
        <div class="main_drop_content">
          <el-table
            class="mytable"
            ref="multipleTable"
            :data="tableData1"
            border
            highlight-current-row
            tooltip-effect="dark"
          >
            <el-table-column
              type="index"
              width="50"
              label="序号"
              align="center"
            >
            </el-table-column>
            <el-table-column label="申请编号" align="center">
              <template slot-scope="scope">{{
                scope.row.apply_number
              }}</template>
            </el-table-column>
            <!-- <el-table-column label="项目编号" align="center">
              <template slot-scope="scope">{{
                scope.row.project_number
              }}</template>
            </el-table-column> -->
            <el-table-column label="委托单位" align="center">
              <template slot-scope="scope">{{
                scope.row.enterprise_client_name
              }}</template>
            </el-table-column>
            <el-table-column label="生产商" align="center">
              <template slot-scope="scope">{{
                scope.row.enterprise_manufacturer_name
              }}</template> </el-table-column
            ><el-table-column label="检测产品" align="center">
              <template slot-scope="scope">{{
                scope.row.product_name
              }}</template>
            </el-table-column>
            <el-table-column label="产品类型" align="center">
              <template slot-scope="scope">{{
                scope.row.product_model
              }}</template>
            </el-table-column>
            <el-table-column label="时间" align="center">
              <template slot-scope="scope">{{
                scope.row.utime | formatDate(scope.row.utime)
              }}</template>
            </el-table-column>
            <el-table-column label="备注" width="160" align="center">
              <template slot-scope="scope">{{
                scope.row.audit_remarks == "-1"
                  ? "不符合要求"
                  : scope.row.audit_remarks
              }}</template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <span
                  v-if="
                    scope.row.business_type == 1 ||
                    scope.row.business_type == 3 ||
                    scope.row.business_type == 5
                  "
                  class="look"
                  @click="toDetails(scope.row)"
                  >编辑</span
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="page_footer">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="npage"
          :page-size="pagesize"
          layout="total, prev, pager, next,jumper"
          background
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate } from "../../filters/filters.js";
import { httpApplycopyMyapply } from "../../utils/myapplication";
export default {
  data() {
    return {
      npage: 1, //当前页
      pagesize: 10, //每页显示条数
      total: 0, //总条数
      tableData: [],
      tableData1: [],
    };
  },
  methods: {
    //分页
    handleSizeChange(val) {
      this.pagesize = val;
      this._httpApplycopyMyapply(this.npage, this.pagesize);
    },
    handleCurrentChange(val) {
      this.npage = val;
      this._httpApplycopyMyapply(this.npage, this.pagesize);
    },
    //编辑
    toDetails(row) {
      console.log(row);
      if (row.business_type == 1) {
        this.$router.push({
          path: "/applicationFormFillInHouse",
          query: { type: 1, nid: row.id },
        });
      } else if (row.business_type == 3) {
        this.$router.push({
          path: "/applicationFormFillInHouse",
          query: { type: 2, nid: row.id },
        });
      } else if (row.business_type == 5) {
        this.$router.push({
          path: "/applicationFormFillInHouse",
          query: { type: 3, id: row.id },
        });
      }
    },
    //未受理申请列表
    _httpApplycopyMyapply(page, pagesize) {
      httpApplycopyMyapply(page, pagesize).then((res) => {
        let data = res.data;
        if (data.code == 0) {
          this.total = data.data.total;
          this.tableData = data.data.hold;
          this.tableData1 = data.data.reject;
        } else {
          this.$message(data.msg);
        }
      });
    },
  },
  filters: {
    formatDate(time) {
      var data = new Date(time * 1000);
      return formatDate(data, "yyyy-MM-dd hh:mm:ss");
    },
  },
  mounted() {
    this._httpApplycopyMyapply(this.npage, this.pagesize);
  },
};
</script>

<style lang="scss" scoped>
.application_not {
  .top {
    border-bottom: 2px solid #ccc;
    padding-bottom: 10px;
  }
  .main {
    .look {
      color: #62b3ff;
      cursor: pointer;
      margin: 0 5px;
    }
    .page_footer {
      display: flex;
      justify-content: flex-end;
      margin: 20px;
    }
    /deep/ .el-table th {
      background-color: #f2f6fc !important;
    }
    .main_drop {
      margin-top: 44px;
      .main_drop_title {
        width: 100%;
        height: 46px;
        line-height: 46px;
        background: #62b3ff;
        color: #fff;
        padding: 0 10px;
        box-sizing: border-box;
      }
      .main_drop_content {
        width: 100%;
        padding: 10px 0;
        box-sizing: border-box;
        // height: 250px;
        // background: #eee;
        .mytable {
          position: relative;
          width: 95%;
          margin: 0 auto;
        }
      }
    }
  }
}
</style>